import { MsalService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import { SiLocaleService } from '@siemens/element-ng/localization';
import { catchError, map, of, take } from 'rxjs';
import { DEFAULT_LOCALE } from '../../core/locale.config';

// Initialize MSAL and handle redirect callbacks
export function initializeMsal(msalService: MsalService) {
    return () => {
        return msalService.handleRedirectObservable().pipe(
            map((): void => {
                // Set the active account after login
                const accounts = msalService.instance.getAllAccounts();
                if (accounts.length > 0) {
                    const activeAccount = msalService.instance.getActiveAccount() || accounts[0];
                    msalService.instance.setActiveAccount(activeAccount);
                }
                return undefined;
            }),
            catchError(error => {
                console.error('Error during MSAL initialization:', error);
                return of(undefined);
            }),
            take(1)
        );
    };
}

// Initialize the translation service with the locale from SiLocaleService
export function initializeLanguage(translateService: TranslateService, localeService: SiLocaleService) {
    return () => {
        const locale = localeService.locale;
        translateService.setFallbackLang(DEFAULT_LOCALE);
        translateService.use(locale);
        return of(undefined);
    };
}
